import { Button } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import arrayUtilities from "../../../utilities/arrayUtilities";

export default function MapOutputToolbox(props) {

    const hasSketchWithLimits = props.sketch !== null && !arrayUtilities.isNullOrEmpty(props.sketch?.limits);

    const onDownloadMapPackage = () => {
        if (props.onDownloadMapPackage) {
            props.onDownloadMapPackage();
        }
    };

    const onDownloadData = (exportFormat) => {
        if (props.onDownloadData) {
            props.onDownloadData(exportFormat);
        }
    };

    const onDownloadScreenshot = () => {
        if (props.onDownloadScreenshot) {
            props.onDownloadScreenshot();
        }
    };

    return <Accordion.Item eventKey='8'>
        <Accordion.Header><i className='fi-download-file me-2' /> Map Output</Accordion.Header>
        <Accordion.Body>
            <div className='d-flex flex-column my-2'>
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={onDownloadScreenshot}>Print Map <i className='fi-image'></i></Button>
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" disabled={!hasSketchWithLimits || props.isSendingMapPackage} onClick={onDownloadMapPackage}>Download Map Package <i className='fi-download'></i></Button>
                {
                    (props.organisationId === '22512ce6-8e0d-436f-9628-7709b534a18f' || props.organisationId === '11ae2b1c-8595-4ea3-82c4-b71792d3fe27') && <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" disabled={!hasSketchWithLimits} onClick={() => props.onDownloadTelusReport && props.onDownloadTelusReport()}>Download Telus Report <i className='fi-file'></i></Button>
                }
                {
                    props.organisationId === '9bcfb192-b687-4de6-a5b5-b30dc5a86ee1' && <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" disabled={!hasSketchWithLimits} onClick={() => props.onDownloadOntarioLocateReport && props.onDownloadOntarioLocateReport()}>Download Ontario Locate Report <i className='fi-file'></i></Button>
                }
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(1)}>Download as KML <i className='fi-code'></i></Button>
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(2)}>Download as Shapefile <i className='fi-layers'></i></Button>
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(3)}>Download as CSV <i className='fi-header'></i></Button>
                <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(4)}>Download as CAD <i className='fi-file-clean'></i></Button>
                {
                    props.organisationId === '1d1c5ced-1508-4042-a345-6ffab44da9c0' &&
                    <>
                        <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(5)}>Download as EM31 CSV <i className='fi-header'></i></Button>
                        <Button size='sm' variant="link" className="d-flex flex-grow-1 justify-content-between align-items-center p-0 mb-2" onClick={() => onDownloadData(6)}>Download as EM38 CSV <i className='fi-header'></i></Button>
                    </>
                }
            </div>
        </Accordion.Body>
    </Accordion.Item>;
}
